"use client";

// The stable right-rail panel shown across every admin-user detail tab.
// Split out of AdminUserDetailTabComponents.tsx (module-size).

import { Badge } from "@west-tennessee-consulting/ui";
import { AdminUserEmailLink } from "@/components/shared/ContactMethodActions/AdminUserEmailLink";
import {
  resolveUserRole,
  getRoleDisplayName,
  getRoleBadgeVariant,
} from "@/lib/constants/user-types";
import type { User } from "@/lib/types/user";

export function AdminUserInfoPanel({ user }: { user: User }) {
  const role = resolveUserRole(user);
  const isActive = user.is_active !== false;

  return (
    <div className="space-y-4">
      <div className="border rounded-lg p-4 bg-white">
        <h3 className="text-sm font-semibold text-gray-900 mb-3">Quick Info</h3>
        <div className="space-y-3 text-sm">
          <div className="flex flex-wrap items-center gap-2">
            {role && <Badge variant={getRoleBadgeVariant(role)}>{getRoleDisplayName(role)}</Badge>}
            <Badge variant={isActive ? "default" : "outline"}>
              {isActive ? "Active" : "Inactive"}
            </Badge>
          </div>
          {user.email && (
            <div>
              <span className="text-gray-600">Email:</span>
              <AdminUserEmailLink user={user} className="text-blue-600 block truncate" showIcon />
            </div>
          )}
          {typeof user.is_billable === "boolean" && (
            <div>
              <span className="text-gray-600">Billable:</span>
              <p className="text-gray-900">{user.is_billable ? "Yes" : "No"}</p>
            </div>
          )}
          {typeof user.available_hours === "number" && (
            <div>
              <span className="text-gray-600">Available hours / week:</span>
              <p className="text-gray-900">{user.available_hours}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
